var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('views',{staticClass:"edit-img"},[_c('views',{staticClass:"edit-img-inner"},[_c('views',{staticClass:"user-img"},[_c('images',{attrs:{"src":_vm.avatar}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }